import LeftSideMenu from './LeftSideMenu';

export default LeftSideMenu;



// WEBPACK FOOTER //
// ./src/components/LeftSideMenu/index.ts